// extracted by mini-css-extract-plugin
module.exports = {"qrcodeWrapper":"ModalSendToPhone_qrcodeWrapper__HS0Y2"};